export type FontFamilyOption = {
  value: string;
  label: string;
};

export const FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
  { value: "Temel Yazi", label: "Temel Yazi" },
  { value: "Temel Yazi Bold", label: "Temel Yazi Bold" },
  { value: "Temel Yazi Light", label: "Temel Yazi Light" },
  { value: "Temel Yazi Kilavuz", label: "Temel Yazi Kilavuz" },
  { value: "Temel Yazi Kontur", label: "Temel Yazi Kontur" },
  { value: "Temel Yazi Kesik Kontur", label: "Temel Yazi Kesik Kontur" },
  { value: "Temel Yazi Kesik Cizgi", label: "Temel Yazi Kesik Cizgi" },
  { value: "Figtree", label: "Figtree" },
  { value: "Quicksand", label: "Quicksand" },
  { value: "Minion Pro", label: "Minion Pro" },
  { value: "Minion Pro Condensed", label: "Minion Pro Condensed" },
  { value: "Chalkboard", label: "Chalkboard" },
  { value: "Ayuthaya", label: "Ayuthaya" },
  { value: "Arial", label: "Arial" },
  { value: "Arial Black", label: "Arial Black" },
  { value: "Arial Narrow", label: "Arial Narrow" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Georgia", label: "Georgia" },
  { value: "Verdana", label: "Verdana" },
  { value: "Helvetica", label: "Helvetica" },
  { value: "Tahoma", label: "Tahoma" },
  { value: "Trebuchet MS", label: "Trebuchet MS" },
  { value: "Courier New", label: "Courier New" },
  { value: "Brush Script MT", label: "Brush Script MT" },
  { value: "Comic Sans MS", label: "Comic Sans MS" },
  { value: "Inter", label: "Inter" },
  { value: "Roboto", label: "Roboto" },
];

export const normalizeFontFamilyValue = (
  value?: string | null
): string => {
  if (!value) {
    return "";
  }
  const first = value.split(",")[0]?.trim() ?? "";
  return first.replace(/^['"]|['"]$/g, "");
};
